<template>
  <transition name="modal" v-if="active">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h4>¡Todo listo!</h4>
          </div>
          <div class="modal-body icon">
            <img src="@/assets/images/check.svg" alt="Error icon" />
          </div>
          <div class="modal-body">
            <p>{{ message }}</p>
          </div>
          <div class="modal-footer">
            <button @click.prevent="$emit('confirm')" class="button accept">
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import  '@/assets/styles/constants.scss';

.button {
  font-size: 1rem;
  border-radius: 20px;
  border: 0;
  padding: 0.6em 1.5em;
  margin: 31px 0;
  cursor: pointer;

  &.accept {
    color: $white;
    background-color: $light-blue;

    &:focus {
      outline-width: 0;
    }
  }

  &.cancel {
    background-color: $white;
    color: $light-blue;
    border: 1px solid $light-blue;

    &:focus {
      outline-width: 0;
    }
  }
}

.button {
  font-size: 0.8em;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6em 1.5em;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border-radius: 20px !important;
}

.modal-header {
  width: 100%;
  display: flex;
  justify-content: center;
}

.modal-body {
  width: 100%;
  display: flex;
  text-align: center;

  &.icon {
    display: block;
  }
}

.modal-footer {
  width: 100%;
  display: flex;
  justify-content: space-around;

}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}
</style>
